import './_lock-box-engraving.scss';
import component from './lock-box-engraving';

export default component;
